var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext, useState, useEffect } from "react";
import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { AuthContext } from "./AuthContextProvider";
import { ApolloProvider } from "@apollo/client/react";
import { SettingsContext } from "./SettingsContextProvider";
import { Box, CircularProgress } from "@mui/material";
export var ApolloWrapper = function (_a) {
    var children = _a.children;
    var globalSettings = useContext(SettingsContext).globalSettings;
    var _b = useContext(AuthContext), keycloakAccessToken = _b.keycloakAccessToken, isAuthContextInitialized = _b.isAuthContextInitialized;
    var _c = useState(null), client = _c[0], setClient = _c[1];
    useEffect(function () {
        if (!isAuthContextInitialized && !globalSettings.DISABLE_AUTH) {
            return;
        }
        if (!keycloakAccessToken && !globalSettings.DISABLE_AUTH) {
            return;
        }
        var httpLink = createHttpLink({
            uri: globalSettings.HASURA_URL,
        });
        var authLink = setContext(function (_, _a) {
            var headers = _a.headers;
            // get the authentication token from local storage if it exists
            // return the headers to the context so httpLink can read them
            return {
                headers: __assign(__assign({}, headers), { authorization: keycloakAccessToken ? "Bearer ".concat(keycloakAccessToken) : "" }),
            };
        });
        var apolloClient = new ApolloClient({
            link: authLink.concat(httpLink),
            cache: new InMemoryCache(),
        });
        setClient(apolloClient);
    }, [
        isAuthContextInitialized,
        keycloakAccessToken,
        globalSettings.HASURA_URL,
        globalSettings.DISABLE_AUTH,
    ]);
    return client === null ? (_jsx(Box, { className: "apollo-loading", sx: { flex: 1, display: "flex", justifyContent: "center", alignItems: "center" }, children: _jsx(CircularProgress, { className: "apollo-loading-progress" }) })) : (_jsx(ApolloProvider, { client: client, children: children }));
};
